import React from "react";
import InternshipCloud from "../Internships/components/InternshipCloud";

const CloudComputing = () => {
  return (
    <>
      <div className="container-fluid py-5 row px-4 bg-light enroll">
        <div className="row p-md-5 align-content-center justify-content-around ">
          {/* <div className=" cloud-sec-outer">

            <h1> Our Cloud-Computing</h1>{" "}
            <img
              className="cloud-sec-image"
              src="https://nextpageit.com/wp-content/uploads/2023/06/Frame-37-1.png"
            />
          </div>

          <div className="col-md-12 mx-3"></div> */}
          <div className='container my-5 enroll'>
            <div className='row py-5  '>

              <div className=" col-md-6 ">
                <div className='mt-5 px-5 me-3'>
                  <div className="">
                    <h3 className="course-heading  " >Cloud Computing</h3>
                    <p className="text-justify ">
                      Cloud computing refers to the delivery of computing services—such as servers, storage,
                      databases, networking, software, over the cloud (internet). The most popular cloud
                      platforms include AWS, Microsoft Azure, and Google Cloud. In this roadmap, you will
                      learn cloud computing fundamentals, public and private clouds, cloud architecture,
                      cloud services, and cloud deployment models. By the end of this roadmap, you’ll have the
                      necessary skills for certification, job search, and practical cloud computing roles.
                    </p>

                  </div>
                </div>
              </div>
              <div className=' col-md-6  ' >
                <div className='mt-2'>
                  <img className="img-fluid mx-auto d-flex" width="100%" src={require('../../assets/images/Hire-our-Wordpress-Developer.png')} /> </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Special title treatment</h5>
                  <p className="card-text">
                    By following these steps, you will gain comprehensive
                    knowledge and insights, ensuring a structured and efficient
                    development process. This will enhance your skills, enabling
                    you to deliver high-quality app and web development projects
                    with confidence and expertise, while continuously improving
                    your technical capabilities.
                  </p>
                  <a href="#" className="btn btn-primary">
                    Go somewhere
                  </a>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <InternshipCloud />
    </>
  );
};

export default CloudComputing;
